<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('userList.userName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.client_id"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginStatus')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('status.enable')" :value="1"></el-option>
								<el-option :label="$t('status.disable')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('userList.buyStatus')" class="mb-0">
							<el-select v-model="from.buy_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('userList.ok')" :value="1"></el-option>
								<el-option :label="$t('userList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="layout.user.type==1" :label="$t('userList.customerType')" class="mb-0">
							<el-select v-model="from.customer_type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('userList.customerType1')" :value="1"></el-option>
								<el-option :label="$t('userList.customerType2')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="layout.user.type==1" :label="$t('userList.agent')" class="mb-0">
							<el-select v-model="from.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('userList.addUser')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="[scope.row.head]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" width="120" prop="client_id" :label="$t('payList.uid')">
				</el-table-column>
				
				<el-table-column align="center" width="140" prop="name" :label="$t('userList.userName')">
				</el-table-column>
				<el-table-column align="center" prop="username" :label="$t('adminList.loginName')">
				</el-table-column>
				<el-table-column align="center" prop="status" width="90" :label="$t('adminList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('adminList.normalLogin') : $t('adminList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column v-if="layout.user.type==1" align="center" prop="buy_status" :label="$t('userList.buyStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.buy_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'buy_status')"
							plain>{{scope.row.buy_status ? $t('userList.ok') : $t('userList.no')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column v-if="layout.user.type==1" align="center" prop="agent_name" :label="$t('userList.agent')">
				</el-table-column>
				
				
				
				<el-table-column  align="center" prop="pay_type" :label="$t('userList.pay_type')">
					
					<template slot-scope="scope">
						<span v-if="scope.row.pay_type==1">{{$t('userList.pay_type1')}}</span>
						<span v-if="scope.row.pay_type==2">{{$t('userList.pay_type2')}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="money" :label="$t('userList.money')">
				</el-table-column>
				<el-table-column v-if="layout.user.type==1" width="140" align="center" prop="quota" :label="$t('userList.quotaHaveZ')">
					<template slot-scope="scope">
						<span class="">{{scope.row.quota}}</span>
						/
						<span class="text_chengse">{{scope.row.have_quota}}</span>
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" prop="need_money" :label="$t('userList.need_money')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				<!-- <el-table-column align="center" prop="have_quota" :label="$t('userList.quotaHave')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.have_quota}}</span>
					</template>
				</el-table-column> -->
				
				
				<el-table-column align="center" prop="account_num" :label="$t('userList.have_account')">
					<template slot-scope="scope">
						<el-link @click="toAccount(scope.row.id)" type="primary" class="text_chengse">{{scope.row.account_num}}</el-link>
					</template>
				</el-table-column>
				
				<el-table-column v-if="layout.user.type==1" align="center" prop="user_type" :label="$t('userList.userType')">
					<template slot-scope="scope">
						{{scope.row.user_type==1?$t('userList.userType1'):$t('userList.userType2')}}
					</template>
				</el-table-column>
				<el-table-column v-if="layout.user.type==1" align="center" prop="customer_type" :label="$t('userList.customerType')">
					<template slot-scope="scope">
						{{scope.row.customer_type==0?$t('userList.customerType2'):$t('userList.customerType1')}}
					</template>
				</el-table-column>
				
				<el-table-column  v-if="layout.user.type==1" width="100" align="center" prop="odds" :label="$t('userList.odds')">
				
				</el-table-column>
				
				<el-table-column  v-if="layout.user.type==1" align="center" prop="warn_limit" :label="$t('userList.warn_limit')">
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="remark" :label="$t('userList.remark')">
				</el-table-column>
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="login_time" :label="$t('userList.loginTime')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="email" :label="$t('userList.email')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="phone" :label="$t('userList.phone')">
				</el-table-column>
				
				<el-table-column width="140" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="success" v-auth="'edit'+auth_val" @click="openRebateModel(scope.row)">{{$t('userRebate.rebate')}}</el-button>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('adminList.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('userList.editUser') : $t('userList.addUser')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('userList.userName')" prop="name">
					<el-input v-model="form.name" :placeholder="$t('userList.userName')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('adminList.loginName')" prop="username">
					<el-input  v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('adminList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginPassword')" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.userType')" v-if="layout.user.type==1">
					<el-radio-group v-model="form.user_type" size="small">
						<el-radio :label="1" border>{{$t('userList.userType1')}}</el-radio>
						<el-radio :label="0" border>{{$t('userList.userType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('userList.customerType')" v-if="layout.user.type==1">
					<el-radio-group v-model="form.customer_type" size="small">
						<el-radio :label="1" border>{{$t('userList.customerType1')}}</el-radio>
						<el-radio :label="0" border>{{$t('userList.customerType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="layout.user.type==1" :label="$t('userList.agent')" prop="agent_id">
					<el-select :disabled="editIndex > -1 && layout.user.type!=1" v-model="form.agent_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('userList.pay_type')" v-if="layout.user.type==1">
					<el-radio-group v-model="form.pay_type" size="small">
						<el-radio :label="1" border>{{$t('userList.pay_type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('userList.pay_type2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('userList.buyStatus')" v-if="layout.user.type==1">
					<el-radio-group v-model="form.buy_status" size="small">
						<el-radio :label="1" border>{{$t('userList.ok')}}</el-radio>
						<el-radio :label="0" border>{{$t('userList.no')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item  v-if="layout.user.type==1" :label="$t('userList.quota')" prop="quota">
					<el-input v-model="form.quota" type="number" :placeholder="$t('userList.quota')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item  v-if="layout.user.type==1" :label="$t('userList.warn_limit')" prop="warn_limit">
					<el-input  v-model="form.warn_limit" type="number" :placeholder="$t('userList.warn_limit')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item  v-if="layout.user.type==1" :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item v-if="layout.user.type==1" label="账单金额加成" prop="add_odds">
					<el-input v-model="form.add_odds" type="number" placeholder="账单金额加成比例" clearable size="small" style="width: 85%;">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item v-if="layout.user.type==1" label="推拉流用量加成" prop="add_live_use">
					<el-input v-model="form.add_live_use" type="number" placeholder="推拉流用量加成比例" clearable size="small" style="width: 85%;">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('userList.email')" prop="email">
					<el-input v-model="form.email" :placeholder="$t('userList.email')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.phone')" prop="phone">
					<el-input v-model="form.phone" :placeholder="$t('userList.phone')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item :label="$t('userList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('adminList.loginStatus')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('adminList.normalLogin')}}</el-radio>
						<el-radio :label="0" border>{{$t('adminList.forbidLogin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('userRebate.title')"
			:visible.sync="rebataModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			
			<div v-loading="rebataLoad" class="userSet">
					<el-table
					ref="tb"
					  :data="rebateData"
					  :row-key="row => String(row.id)"
					  :expand-row-keys="expandedKeys"
					  border
					  stripe
					  row-key="id"
					  style="width: 100%;"
					>
					  <!-- 展开列：默认不展开 -->
					  <el-table-column  type="expand"  width="1">
					    <template slot-scope="{row}" style="width: 100%;">
							
							<el-card class="bar" style="width: 100%;">
							      <div style="display: flex;justify-content: flex-end;align-items: center;">
							        <span class="bar-label">{{$t('upay.yset')}}：</span>
							        <el-input-number
							          v-model="ySet"
							          :min="100 - row.rebate"
							          :max="100"
							          :precision="2"
							          :step="0.01"
									  size="small"
							          controls-position="right"
							          class="mr-5"
							        />
									
								
							        <div class="mr-5">
										<el-button class=" mr-1" size="small" type="success" @click="changeAllDomainRebate(domain_arr)" >
										  {{$t('upay.look')}}
										</el-button>
										<el-button class=" mr-5" size="small" type="primary" @click="updateRebateAll(row)" :disabled="row.load" :loading="row.load">
										  {{$t('cdnd.edit')}}
										</el-button>
									</div>
							        
							      </div>
							    </el-card>
								
								
							<el-table class="noHideR" :height="400" :data="domain_arr"
							 style="width: 100%;" size="mini" >	
								
								
											
								<el-table-column type="expand" :label="$t('status.log')" width="50">
									
								  <template slot-scope="{row}" style="width: 100%;">
									  
									<el-table  :height="400" :data="row.data"
									 style="width: calc(100% - 50px);margin-left: 50px;" size="mini" >							<!-- 域名后缀 -->
									 
								
										<el-table-column align="center"  prop="suffix" :label="$t('domainPrice.domainSuffix')">
											<template slot-scope="scope">
											  <span class="suffix-text">{{ scope.row.suffix }}</span>
											</template>
		
										</el-table-column>
										
										<!-- 操作类型 -->
										<el-table-column prop="type" :label="$t('domainPrice.operationType')"  align="center">
											<template slot-scope="scope">
											  <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeText(scope.row.type) }}</el-tag>
											</template>
										  </el-table-column>
										<!-- 年限 -->
										<el-table-column prop="years" :label="$t('domainPrice.years')"  align="center">
											<template slot-scope="scope">
											  {{ scope.row.years }}{{ $t('domain.year') }}
											</template>
										  </el-table-column>
		
		
										<!-- 成本价 -->
										<el-table-column prop="cost_price" :label="$t('domainPrice.costPrice')"  align="center">
											<template slot-scope="scope">
											  <span class="price-text">${{ scope.row.cost_price }}</span>
											</template>
										</el-table-column>
		
										
										<!-- 当前价格 -->
										<el-table-column prop="price" :label="$t('domainPrice.currentPrice')"  align="center">
											<template slot-scope="scope">
											  <span class="price-text price-current">${{ scope.row.price }}</span>
											</template>
										  </el-table-column>
										  
										<!-- 返佣比例 -->
										
										<el-table-column prop="price" :label="$t('userRebate.odds')"  align="center">
											<template slot-scope="scope">
											  <span >${{ row.rebate }} %</span>
											</template>
										</el-table-column>
										
										<!-- 代理成本 -->
										<el-table-column prop="price" :label="$t('userRebate.userprice')"  align="center">
											<template slot-scope="scope">
											  <span class="price-text price-current">${{ getAgentPrice(scope.row,row.rebate) }}</span>
											</template>
										</el-table-column>
		
										
										<!-- 利润 -->
										<!-- <el-table-column :label="$t('domainPrice.profit')"  align="center">
											<template slot-scope="scope">
											  <span :class="getProfitClass(scope.row)">${{ getProfit(scope.row) }}</span>
											</template>
										</el-table-column> -->
		
										
										
										
										
										
									</el-table>
								</template>
								</el-table-column>
								
								<el-table-column align="center"  prop="suffix" :label="$t('domainPrice.domainSuffix')">
									<template slot-scope="scope">
									  <span class="suffix-text">{{ scope.row.suffix }}</span>
									</template>
		
								</el-table-column>
								
								<!-- 操作类型 -->
								<el-table-column prop="type" :label="$t('domainPrice.operationType')"  align="center">
									<template slot-scope="scope">
									  <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeText(scope.row.type) }}</el-tag>
									</template>
								  </el-table-column>
								
		
							
		
								<!-- 域名后缀成本设置 -->
								<el-table-column prop="price" :label="$t('userRebate.userodds')"  align="center">
									<template slot-scope="{ row }">
									  <div class="percent-input">
									    <el-input-number
									      v-model.number="row.rebate"
									      :min="row.min"
									      :max="100"
									      :step="0.01"
											:precision="2"
									      controls-position="right"
									      size="small"
									      style="width: 160px;"
										  @input="limitRebate(row)"
										  @change="limitRebate(row)"
									    />
									    <span class="suffix">%</span>
									  </div>
									</template>
								</el-table-column>
								
								
								<el-table-column :label="$t('layout.operation')" align="center"  >
								  <template slot-scope="{ row }">
								    
								    <el-button :disabled="row.load" :loading="row.load" size="mini" @click="updateRebate(row)" type="primary" >{{$t('cdnd.edit')}}</el-button>
								  </template>
								</el-table-column>
		
								
								<!-- 利润 -->
								<!-- <el-table-column :label="$t('domainPrice.profit')"  align="center">
									<template slot-scope="scope">
									  <span :class="getProfitClass(scope.row)">${{ getProfit(scope.row) }}</span>
									</template>
								</el-table-column> -->
		
								
								
							    
								
								
							</el-table>
						</template>
					  </el-table-column>
					
					
							
					 
						<el-table-column align="center" prop="type" :label="$t('aglevel.type')">
							<template slot-scope="scope">
								<span v-if="scope.row.type==1">{{$t('aglevel.domain')}}</span>
							</template>
						</el-table-column>
												
												
												
										
					  <el-table-column :label="$t('aglevel.aglevel')" align="center" min-width="180">
					    <template slot-scope="{ row }">
					      {{row.name}}
					    </template>
					  </el-table-column>
										
					  <el-table-column :label="$t('aglevel.rebate')" align="center" min-width="220">
					    <template slot-scope="{ row }">
							<span>{{row.rebate}}%</span>
						</template>
					      
					  </el-table-column>
					  
					  
					  <el-table-column :label="$t('aglevel.is_open')" align="center" min-width="220">
					    <template slot-scope="{ row }">
						
							<el-button :disabled="row.load" :loading="row.load"
								:type="row.is_open ? 'success' : 'danger'" 
								size="mini"
								@click="changeOpenStatus(row)"
								plain>{{row.is_open ? $t('aglevel.is_open1') : $t('aglevel.is_open2')}}
							</el-button>
						</template>
					      
					  </el-table-column>
										
					  
					  <!-- 自定义按钮列 -->
					    <el-table-column :label="$t('userRebate.set')" width="120" align="center">
					      <template slot-scope="{ row }">
					        <el-button size="mini" type="primary" @click="toggleExpand(row)">
					          {{ $t('userRebate.set')}}
					        </el-button>
					      </template>
					    </el-table-column>
										
				
					</el-table>
			</div>
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
		
		       <!-- <el-form-item :label="$t('aglevel.max')" prop="max">
		        	<el-input  v-model="form.max" type="number"  :placeholder="$t('aglevel.max')" clearable size="small" style="width: 85%;" ></el-input>
		        
		        	<div style="font-size: 12px;color: gray;">{{$t('aglevel.maxTis')}}</div>
		        </el-form-item> -->
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="rebataModel = false">{{$t('cdnd.close')}}</el-button>
				<!-- <el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button> -->
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				domain_arr:[],
				rebateData:[],
				rebataModel:false,
				rebataLoad:false,
				createModel: false,
				editIndex: -1,
				user_odds:0,
				ySet:null,
				//搜索數据
				from: {
					name: '',
					username:'',
					client_id:'',
					status:-1,
					agent_id:-1,
					buy_status:-1,
					customer_type:-1,
					time:[],
				},
				auth_val: 'User',
				expandedKeys: [],           // 已展开行的 keys
				preUrl: "user/userList", //列表地址
				delAllUrl: "user/delUserAll", //批量删除地址
				delUrl: "user/delUser", //删除單条地址
				addUrl: "user/addUser", //添加/修改地址
				editStatusUrl:"user/editStatusUser",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}],
					password: [{
						min: 6,
						max: 16,
						message: this.$t('adminList.passwordLength'),
						trigger: 'blur'
					}],
					agent_id: [{
						required: true,
						message: this.$t('userList.selAgent'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('agent');
		},
		methods: {
			keyOf(row) { return String(row.id); },
			    isExpanded(row) {
			      return this.expandedKeys.includes(this.keyOf(row));
			    },
			    toggleExpand(row) {
			      const id = this.keyOf(row);
			      if (this.isExpanded(row)) {
			        // 收起
			        this.expandedKeys = this.expandedKeys.filter(k => k !== id);
			      } else {
			        // 展开（手风琴就用 this.expandedKeys=[id]）
			        this.expandedKeys = [...this.expandedKeys, id];
			      }
			    },
			changeAllDomainRebate(domain_arr){
				for(let i =0;i<domain_arr.length;i++){
					domain_arr[i].rebate = this.ySet
				}
			},
			changeOpenStatus(row){
				
				row.load = true
				console.log(row)
				this.axios.post('/admin/user/editUserOpenStatus', {
					is_open:row.is_open,
					uid:row.uid,
					type:row.type
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(list)
					row.is_open = list
					//this.$message.success(all.msg);
					row.load = false;
				}).catch(err => {
					// 失敗
					row.load = false;
					this.$message.error(all.msg);
				})
				
			},
			updateRebateAll(row){
				row.load = true
				console.log(row)
				this.axios.post('/admin/user/editUserRebate', {
					edit_type:'all',
					id:row.id,
					type:row.type,
					uid:row.uid,
					rebate:this.ySet
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(all)
					this.$message.success(all.msg);
					row.load = false;
				}).catch(err => {
					// 失敗
					row.load = false;
					this.$message.error(all.msg);
				})
			},
			updateRebate(row){
				row.load = true
				console.log(row)
				this.axios.post('/admin/user/editUserRebate', {
					edit_type:'one',
					id:row.id,
					rebate:row.rebate,
					type:row.type,
					suffix:row.suffix,
					uid:row.uid,
					type_id:row.type_id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(all)
					this.$message.success(all.msg);
					row.load = false;
				}).catch(err => {
					// 失敗
					row.load = false;
					this.$message.error(all.msg);
				})
			},
			// 获取操作类型文本
			    getTypeText(type) {
			      const typeMap = {
			        'register': this.$t('domainPrice.register'),
			        'renew': this.$t('domainPrice.renew'),
			        'transfer': this.$t('domainPrice.transfer')
			      }
			      return typeMap[type] || type
			    },
			
			    // 获取操作类型标签类型
			    getTypeTagType(type) {
			      const typeMap = {
			        'register': 'success',
			        'renew': 'warning',
			        'transfer': 'info'
			      }
			      return typeMap[type] || ''
			    },
			
			    // 计算利润
			    getProfit(row) {
			      const profit = parseFloat(row.price) - parseFloat(row.cost_price)
			      return profit.toFixed(2)
			    },
				
				// 计算代理价格
				getAgentPrice(row,rebate) {
				  const profit = this.getProfit(row)
				  const price = parseFloat(row.price) * (parseFloat(rebate) / 100)
				  return price.toFixed(2)
				},
				
			
				
				// 获取利润样式类
				getProfitClass(row) {
				  const profit = parseFloat(row.price) - parseFloat(row.cost_price)
				  if (profit > 0) {
					return 'profit-positive'
				  } else if (profit < 0) {
					return 'profit-negative'
				  } else {
					return 'profit-zero'
				  }
				},
			openRebateModel(item){
				this.rebataModel = true
				
				this.rebataLoad = true;
				this.axios.post('/admin/user/checkAgentRebate', {
					aid: 0,
					type:'user',
					uid:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rebateData = list.list
					this.domain_arr = list.domain_arr
					this.rebataLoad = false;
				}).catch(err => {
					// 失敗
					this.rebataLoad = false;
				})
				
			},
			
			limitRebate(row) {
			  // 固定最大 100
			  const MAX = 100
			
			  // 解析最小值；未设置则默认为 0
			  let min = Number(row?.min)
			  if (!Number.isFinite(min)) min = 0
			  if (min > MAX) min = MAX   // 极端场景：min > 100，则收敛到 100
			
			  // 解析当前值；非法则置为 min
			  let v = Number(row?.rebate)
			  if (!Number.isFinite(v)) { row.rebate = Number(min.toFixed(2)); return }
			
			  // 先夹逼到 [min, 100]
			  if (v < min) v = min
			  if (v > MAX) v = MAX
			
			  // 保留两位（四舍五入）
			  v = Number(v.toFixed(2))
			
			  // 二次保险：避免四舍五入后越界
			  if (v > MAX) v = Number(MAX.toFixed(2))
			  if (v < min) v = Number(min.toFixed(2))
			
			  row.rebate = v
			},
			
			toAccount(id){
				let checkUserAccount = {}
				checkUserAccount.name = id
				this.$router.push({
					name: 'account',
					params:{checkUserAccount:checkUserAccount}
				})
			},
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('adminList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) { 
			    // 增加 
			    console.log(e) 
			    if (!e) { 
			     // 初始化表單 
			     this.form = { 
			      id:0, 
			      name: "", 
			      username: '', 
			      password: '', 
			      password2: '', 
			      headUrl: '', 
			      icon:'', 
			      status: 1, 
			      user_type:1, 
			      customer_type:1,
			      agent_id:'', 
			      buy_status:1, 
			      warn_limit:1000, 
			      pay_type:1, 
			      odds:this.user_odds, 
			      add_odds:0,
			      add_live_use:0,
			      email:'', 
			      phone:'', 
			      quota:0, 
			      remark:'', 
			      headId: 0, 
			     } 
			     this.editIndex = -1 
			    } else { 
			     // 修改 
			     this.form = { 
			      id:e.id, 
			      name: e.name, 
			      username: e.username, 
			      password: '', 
			      password2: '', 
			      headUrl: e.head, 
			      icon:e.head, 
			      status: e.status, 
			      user_type:e.user_type, 
			      customer_type:e.customer_type == 0 ? 0 : 1,
			      agent_id:e.agent_id, 
			      warn_limit:e.warn_limit, 
			      buy_status:e.buy_status, 
			      pay_type:e.pay_type, 
			      quota:e.quota, 
			      odds:e.odds, 
			      add_odds:e.add_odds || 0,
			      add_live_use:e.add_live_use || 0,
			      email:e.email, 
			      phone:e.phone, 
			      remark:'', 
			      headId: 0, 
			     } 
			     this.editIndex = e.id 
			    } 
			     
			    // 打开dialog 
			    this.createModel = true 
			   },
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list.agent
					this.user_odds = list.user_odds
					console.log(res)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
			
			    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
			    const isLt2M = file.size / 1024 / 1024 < 12;
			
			    if (!isJPG) {
			    this.$message.error(this.$t('message.info_err'));
			    }
			    if (!isLt2M) {
			    this.$message.error(this.$t('message.img_max_err'));
			    }
			    return isJPG && isLt2M;
			
			   },
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					client_id:'',
					status:-1,
					agent_id:-1,
					buy_status:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.suffix-text {
  font-weight: bold;
  color: #409EFF;
}

.price-text {
  font-weight: bold;
}

.price-current {
  color: #67C23A;
}

.profit-positive {
  color: #67C23A;
  font-weight: bold;
}

.profit-negative {
  color: #F56C6C;
  font-weight: bold;
}

.profit-zero {
  color: #909399;
  font-weight: bold;
}

.delete-btn {
  color: #F56C6C;
}

.delete-btn:hover {
  color: #F56C6C;
}





.userSet .el-table__expand-icon{
	display: none;
}

.noHideR .el-table__expand-icon{
	display: block;
}

</style>
